import { useOpcInfomation } from '../../../hooks/useOpcInfomation';
import AddCoverageModal from './AddCoverageModal';
import AdjustCoverageModal from './AdjustCoverageModal';
import EditCoverableAttributeModal from './EditCoverableAttributeModal';
import RemoveCoverageModal from './RemoveCoverageModal';
import { type HandleCloseOPCModal } from '../types';

const OpcModal = ({
    modal,
    handleCloseModal,
    shouldNavigateToShoppingBasket
}: {
    modal: string;
    handleCloseModal: HandleCloseOPCModal;
    shouldNavigateToShoppingBasket: boolean;
}): React.JSX.Element => {
    const { adjustAction } = useOpcInfomation().termChange;
    switch (modal) {
        case 'attribut':
            return <EditCoverableAttributeModal handleCloseModal={handleCloseModal} />;
        case 'tilfoej':
            return <AddCoverageModal handleCloseModal={handleCloseModal} />;
        case 'tilpas':
            switch (adjustAction) {
                case 'Remove':
                    return (
                        <RemoveCoverageModal
                            handleCloseModal={handleCloseModal}
                            shouldNavigateToShoppingBasket={shouldNavigateToShoppingBasket}
                        />
                    );
                case 'Deductible':
                case 'InjuryDegree':
                case 'Limit':
                case 'AudioTelcoDropdown':
                case 'PRHPrivateContentSum':
                case 'UVPContentSum':
                    return (
                        <AdjustCoverageModal
                            handleCloseModal={handleCloseModal}
                            shouldNavigateToShoppingBasket={shouldNavigateToShoppingBasket}
                        />
                    );
                default:
                    return <></>;
            }
        default:
            return <></>;
    }
};

export default OpcModal;
